import { render, staticRenderFns } from "./CallNumSingleList.vue?vue&type=template&id=4817540c&scoped=true&"
import script from "./CallNumSingleList.vue?vue&type=script&lang=js&"
export * from "./CallNumSingleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4817540c",
  null
  
)

export default component.exports